/*
 * S3 Functions and Constants
 */

// Given a specific s3 url, it uploads or updates the image at that url
export const putImage = async (url: string, image: File) => {
  await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body: image,
  });
};

/*
 * Cloudfront Functions and Constants
 */

// Cloudfront Url
export const { REACT_APP_PROFILE_IMAGE_CLOUDFRONT_URL } = process.env;

// Converts s3 put url into cloudfront url
export const s3ToCloudfrontUrl = (s3Url: string) => {
  // Takes just the part of the s3 url to get the resource
  const s3GetUrl = s3Url.split('?')[0];

  // Replaces s3 domain with cloudfront domain
  const s3UrlSplit = s3GetUrl.split('/');
  return `${REACT_APP_PROFILE_IMAGE_CLOUDFRONT_URL}/${s3UrlSplit[s3UrlSplit.length - 1]}`;
};
